import TextButton from './component.styles'
export default TextButton
